import React, { useState,useEffect } from 'react';
import { useUserAPI } from '../../components/useUserAPI';

import styles from '../../styles/KujiList.module.scss';

// import useSound from 'use-sound';
// import se_08 from '../../sound/s08_se_delay0.mp3';

export function KujiList(props) {


//----------------------------------------
//初期化
//----------------------------------------

const { lotteryhistoryAPI, data: lotteryhistoryData, loading: lotteryhistoryLoading, error: lotteryhistoryError } = useUserAPI();
const { lotteryreceiptAPI, data: lotteryreceiptData, loading: lotteryreceiptLoading, error: lotteryreceiptError } = useUserAPI();

const [receiptTarget, setReceiptTarget] = useState();

useEffect(() => {
	document.getElementById('header').classList.remove('is_behind');

	lotteryhistoryAPI();

	//arrows We 対応
	// document.documentElement.style.zoom = window.innerWidth / 390;
	// var zratio = window.innerWidth / 390;
	if(window.innerWidth >= 320){
		document.documentElement.style.zoom = window.innerWidth / 390;
		var zratio = window.innerWidth / 390;
	}else{
		document.documentElement.style.zoom = 1;
		var zratio = 1;
	}
	let hratio = window.innerHeight / (window.innerHeight * zratio);
	let realheight = window.innerHeight * hratio;
	let elementA = document.getElementById('kuji_list');
	if (elementA) {
		elementA.style.height = realheight + 'px';
	}

	document.querySelectorAll('.loadingBox01').forEach(function(element) {
		element.classList.remove('is_show');
	});
	document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
		element.classList.remove('is_show');
	});

	setTimeout(function(){
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.remove('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.remove('is_show');
		});
	}, 1000);
}, []);


useEffect(() => {
	//お買物API：画面遷移API（くじ抽選結果一覧画面
	props.okaimonoAPI_didScreenTransition("lottery_history");
}, []);


//----------------------------------------
//くじ引き履歴API：レスポンス
//----------------------------------------

useEffect(() => {
	if(lotteryhistoryData){
		if (lotteryhistoryData.data) { //SUCCESS
			console.log("抽出前: ");
			console.log(lotteryhistoryData.data.prizeList);

			// const prizeList = [
			// 	{transactionno: 49965, number: 1, lotteryResult: 0, prizeName: "", prizeImg: "https://dev-image.irs-test.jp/promotion/lose.png"},
			// 	{transactionno: 49965, number: 2, lotteryResult: 1, prizeName: "飲料もしくはお菓子いずれか１つ", prizeImg: "https://dev-image.irs-test.jp/promotion/3rd.png"},
			// 	{transactionno: 49965, number: 3, lotteryResult: 1, prizeName: "飲料もしくはお菓子いずれか１つ", prizeImg: "https://dev-image.irs-test.jp/promotion/3rd.png"}
			// ];

			// const filteredPrizeList = lotteryhistoryData.data.prizeList.filter(item => item.lotteryResult !== 0);
			const filteredPrizeList = lotteryhistoryData.data.prizeList.filter(item => item.lotteryResult !== 0 && item.transactionno === props.shoppingStData.data.transactionno);

			console.log("抽出後: ");
			console.log(filteredPrizeList);

			// props.setPrizeList(lotteryhistoryData.data.prizeList);
			props.setPrizeList(filteredPrizeList);

		}else{ //ERROR
			console.log(`【lotteryhistoryAPI】 errorCode: ${lotteryhistoryData.errorCode}`);
			console.log(`【lotteryhistoryAPI】 errorMessage: ${lotteryhistoryData.errorMessage}`);
			console.log(`【lotteryhistoryAPI】 isSuccess: ${lotteryhistoryData.isSuccess}`);

			// if(payData.errorCode == "26" || payData.errorCode == "27"){
			// 	//トークン不正、トークン有効期限切れ のためアプリ起動後の画面へ（再読込
			// 	window.location.reload();
			// }else{
			// 	props.setErrNum(`${payData.errorCode}`);
			// 	props.setShowModal(true);
			// 	props.setErrTxt(`${payData.errorMessage}`);
			// }
			if(lotteryhistoryData.errorCode === "26"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${lotteryhistoryData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_26]);
				// props.setErr([true,`${lotteryhistoryData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[26];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[26]`]);
			}else if(lotteryhistoryData.errorCode === "27"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${lotteryhistoryData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_27]);
				// props.setErr([true,`${lotteryhistoryData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[27];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[27]`]);
			}else{
				props.setErrFlg(true);
				// props.setErr([true,`${lotteryhistoryData.errorCode}`,`${lotteryhistoryData.errorMessage}`]);
				props.setErr([true,`999`,`${lotteryhistoryData.errorMessage}`]);
			}
		}
	}
	if(lotteryhistoryError){
		console.log("lotteryhistoryError");
		console.log(lotteryhistoryError);
		props.setErrFlg(true);
		props.setErr([true, process.env.REACT_APP_ERROR_CODE_999, process.env.REACT_APP_ERROR_MESSAGE_999]);
		// props.setErr([true,`999`,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		// props.setErr([true,`999`,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
	}
	if(lotteryhistoryLoading){
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.add('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.add('is_show');
		});
	}else{
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.remove('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.remove('is_show');
		});
	}
}, [lotteryhistoryData,lotteryhistoryLoading,lotteryhistoryError]);


//----------------------------------------
//景品受取API：レスポンス
//----------------------------------------

useEffect(() => {
	if(lotteryreceiptData){
		if (lotteryreceiptData.isSuccess === true) { //SUCCESS
			console.log(`【lotteryreceiptAPI】 isSuccess: ${lotteryreceiptData.isSuccess}`);
			if(receiptTarget){
				document.getElementById(receiptTarget).classList.add(styles.is_disabled);
				setReceiptTarget();
			}
			lotteryhistoryAPI();
		}else{ //ERROR
			console.log(`【lotteryreceiptAPI】 errorCode: ${lotteryreceiptData.errorCode}`);
			console.log(`【lotteryreceiptAPI】 errorMessage: ${lotteryreceiptData.errorMessage}`);
			console.log(`【lotteryreceiptAPI】 isSuccess: ${lotteryreceiptData.isSuccess}`);

			// if(payData.errorCode == "26" || payData.errorCode == "27"){
			// 	//トークン不正、トークン有効期限切れ のためアプリ起動後の画面へ（再読込
			// 	window.location.reload();
			// }else{
			// 	props.setErrNum(`${payData.errorCode}`);
			// 	props.setShowModal(true);
			// 	props.setErrTxt(`${payData.errorMessage}`);
			// }
			if(lotteryreceiptData.errorCode === "26"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${lotteryreceiptData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_26]);
				// props.setErr([true,`${lotteryreceiptData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[26];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[26]`]);
			}else if(lotteryreceiptData.errorCode === "27"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${lotteryreceiptData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_27]);
				// props.setErr([true,`${lotteryreceiptData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[27];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[27]`]);
			}else{
				props.setErrFlg(true);
				props.setErr([true,`${lotteryreceiptData.errorCode}`,`${lotteryreceiptData.errorMessage}`]);
			}
		}
	}
	if(lotteryreceiptError){
		console.log("lotteryreceiptError");
		console.log(lotteryreceiptError);
		props.setErrFlg(true);
		props.setErr([true,``, process.env.REACT_APP_ERROR_MESSAGE_TIMEOUT]);
		// props.setErr([true,``,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		// props.setErr([true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
	}
	if(lotteryreceiptLoading){
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.add('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.add('is_show');
		});
	}else{
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.remove('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.remove('is_show');
		});
	}
}, [lotteryreceiptData,lotteryreceiptLoading,lotteryreceiptError]);


//----------------------------------------
//景品受取API：ボタンクリック
//----------------------------------------

const getPrize = (pindex,ptransactionno,pnum) => {
	lotteryreceiptAPI(ptransactionno,pnum);
	let ta = "kujiList_box_btn"+pindex;
	setReceiptTarget(ta);
	// document.getElementById(ta).classList.add(styles.is_disabled);
	// se08_se();
	props.setSoundState("se08_se");
}


// const ShowModal = () => {
// 	props.setShowModal(true)
// }

const closeKujiList = () => {
	// props.setPage("regi_yujin")
	console.log("props.regiType: " + props.regiType);
	props.setPage(props.regiType);
	// se08_se();
	props.setSoundState("se08_se");
}
const getFormattedDateTime = () => {
	const now = new Date();

	const month = now.getMonth() + 1; // 月は0から始まるので、1を加える
	const day = now.getDate();
	const hours = String(now.getHours()).padStart(2, '0');
	const minutes = String(now.getMinutes()).padStart(2, '0');
	const seconds = String(now.getSeconds()).padStart(2, '0');

	return `${month}月${day}日 ${hours}:${minutes}:${seconds}`;
}

return (
	<>
	<div id="kuji_list" className={styles.kujiList}>

		<p className={styles.kujiList_date}><strong>現在時刻</strong>{getFormattedDateTime()}</p>

		<div className={styles.kujiList_list}>
			{
				(() => {
					if (props.prizeList) {
						// if(props.prizeList.length > 1000){
						if(props.prizeList.length > 0){
							return(
								props.prizeList.length > 0 &&
								props.prizeList.map((item, index) => (
									<div key={index} className={styles.kujiList_box}>
										<div className={styles.kujiList_box_img}>
											<img src={item.ticketImg} alt="" width="326" height="273" />
										</div>
										<div className={styles.kujiList_box_btnBox}>
											<div id={`kujiList_box_btn${index}`} className={`${styles.kujiList_box_btn} ${item.lotteryReceiptFlag === 1 ? styles.is_disabled : ''}`} onClick={()=>{getPrize(index,item.transactionno,item.number)}}>景品を受け取った</div>
										</div>
									</div>
									// <div id={`kuji_r${index+1}`} key={index} className={`kujiResult ${item.lotteryResult === 0 ? 'kujiResult_lose' : ''}`}>
									// 	<img src={item.prizeImg} alt="" width="333" height="453" />
									// </div>
								))
							)
						}else{
							return(
							// <div className={styles.kujiList_list}>
								<div className={styles.kujiList_noTicket}>
									<p className={styles.kujiList_noTicket_tit}>交換できる当選券が<br/>ありません。</p>
									<div className={styles.kujiList_noTicket_img}>
										<img src="/images/kuji/kuji_noticket.svg" alt="" width="160" height="160" />
									</div>
								</div>
							// </div>
							)
						}
					}
					// }else{
					// 	return(
					// 	<div className="kujiList_list">
					// 		<div className="kujiList_noTicket">
					// 			<p className="kujiList_noTicket_tit">交換できる当選券がありません。</p>
					// 			<div className="kujiList_noTicket_img">
					// 				<img src="/images/kuji/kuji_noticket.png" alt="" width="300" height="250" />
					// 			</div>
					// 		</div>
					// 	</div>
					// 	)
					// }
				})()
			}
			{/* <div className={styles.kujiList_box}>
				<div className={styles.kujiList_box_img}>
					<img src="/images/kuji/1st_ticket.png" alt="" width="360" height="302" />
				</div>
				<div className={styles.kujiList_box_btnBox}>
					<button className={`${styles.kujiList_box_btn}`}>景品を受け取った</button>
				</div>
			</div>
			<div className={styles.kujiList_box}>
				<div className={styles.kujiList_box_img}>
					<img src="/images/kuji/2nd_ticket.png" alt="" width="360" height="302" />
				</div>
				<div className={styles.kujiList_box_btnBox}>
					<button className={`${styles.kujiList_box_btn} ${styles.is_disabled}`}>景品を受け取った</button>
				</div>
			</div>
			<div className={styles.kujiList_box}>
				<div className={styles.kujiList_box_img}>
					<img src="/images/kuji/3rd_ticket.png" alt="" width="360" height="302" />
				</div>
				<div className={styles.kujiList_box_btnBox}>
					<button className={`${styles.kujiList_box_btn}`}>景品を受け取った</button>
				</div>
			</div>
			<div className={styles.kujiList_box}>
				<div className={styles.kujiList_box_img}>
					<img src="/images/kuji/4th_ticket.png" alt="" width="360" height="302" />
				</div>
				<div className={styles.kujiList_box_btnBox}>
					<button className={`${styles.kujiList_box_btn}`}>景品を受け取った</button>
				</div>
			</div> */}
		</div>

		{/* <div className={styles.kujiList_bottom}>
			<button className={styles.kujiList_closeBtn} onClick={closeKujiList}>くじ結果を閉じる</button>
		</div> */}

	</div>
	</>
)

}
